import React from "react";

import { CustomSpin } from "_components";

export const LoadingOverlay = ({loadingMessage}) => <CustomSpin tip={loadingMessage}/>;

export const NoRowsOverlay = ({loadingMessage}) => <div className="flex-row align-items-center">{loadingMessage}</div>;